import { useMemo } from "react";
import { useSearchParams } from "react-router";

export function useLayerVisibility() {
    const [searchParams, setSearchParams] = useSearchParams();

    const visibleLayerIds = useMemo(() => {
        const param = searchParams.get("layerIds");
        return param ? param.split(",").filter(Boolean) : [];
    }, [searchParams]);

    const showAllLayersByDefault = useMemo(() => {
        return !searchParams.has("layerIds");
    }, [searchParams]);

    const showAllLayers = () => {
        const params = new URLSearchParams(searchParams.toString());
        params.delete("layerIds");
        setSearchParams(params, { replace: true });
    };

    const setVisibleLayerIds = (ids: string[]) => {
        const params = new URLSearchParams(searchParams.toString());

        if (ids.length === 0) {
            params.set("layerIds", "");
        } else {
            params.set("layerIds", ids.join(","));
        }

        setSearchParams(params, { replace: true });
    };

    return {
        visibleLayerIds,
        showAllLayersByDefault,
        showAllLayers,
        setVisibleLayerIds,
    };
}
